/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".note-preview-box[_ngcontent-%COMP%]{position:relative;padding:5px;border:1px dashed #ececec;margin-bottom:30px}.note-preview-box[_ngcontent-%COMP%]   .created-at[_ngcontent-%COMP%]{position:absolute;top:-20px;right:0;font-size:.8rem}.note-preview-box[_ngcontent-%COMP%]   .created-by[_ngcontent-%COMP%]{position:absolute;top:-20px;left:0;font-size:.8rem}"];
export { styles as styles };
